<template>
  <div class="eda">
    <div class="container">
      <div class="row">
        <div
          class="alert alert-warning col-lg-12"
          role="alert"
          v-if="info.ApprovedByAdmin == 1"
        >
          {{ pendingProfileNote }}
        </div>
        <div
          class="alert alert-warning col-lg-12"
          role="alert"
          v-if="info.ApprovedByAdmin == 3"
        >
          {{ rejectedProfileNote }}
        </div>
      </div>
      <div class="profile" v-if="!changeEmailFlag">
        <div class="profile-header row">
          <div class="col-xs-12 col-lg-6 profile-header__user-info">
            <div class="profile-header__user-info__profile-pic">
              <div
                class="profile-header__user-info__profile-pic__image"
                v-bind:style="{
                  backgroundImage: 'url(' + info.ProfilePicture + ')',
                }"
              ></div>
              <div
                class="toaster"
                v-bind:class="{ 'show-toaster': validExtenstion }"
              >
                {{ extvalidation }}
              </div>

              <div class="toaster" v-bind:class="{ 'show-toaster': validSize }">
                {{ sizevalidation }}
              </div>

              <div
                class="profile-header__user-info__profile-pic__upload"
                @click="uploadImg"
                v-if="info.ApprovedByAdmin != 1"
              >
                <i class="far fa-edit"></i>
                <div
                  class="profile-header__user-info__profile-pic__upload__text"
                  id="showProfileImgUploader"
                >
                  {{ uploadingimg }}
                </div>
                <input
                  type="file"
                  id="userImg"
                  style="display:none"
                  @change="imageSelected"
                  v-if="info.ApprovedByAdmin != 1"
                />
              </div>

              <div
                class="profile-header__user-info__profile-pic__upload--dimmed"
                @click="uploadImg"
                v-if="info.ApprovedByAdmin == 1"
              >
                <i class="far fa-edit"></i>
                <div
                  class="profile-header__user-info__profile-pic__upload__text"
                >
                  {{ uploadingimg }}
                </div>

                <input
                  type="file"
                  id="userImg"
                  style="display:none"
                  v-if="info.ApprovedByAdmin == 1"
                />
              </div>
            </div>
            <div class="profile-header__user-data">
              <div>{{ info.FullNameEnglish }}</div>
              <div>{{ info.FullNameArabic }}</div>
              <div>{{ info.Email }}</div>
              <div>{{ info.Address }}</div>
              <a
                :href="forgetPasswordPageUrl"
                class="profile-header__user-data__change-password"
                v-if="info.ApprovedByAdmin != 1"
                >{{ changepassword }}</a
              >
              <a
                href="javascript:void(0)"
                @click.prevent="changeEmail()"
                v-if="info.ApprovedByAdmin != 1"
                class="profile-header__user-data__change-password"
                >{{ formEmailTitle }}</a
              >
              <a
                v-if="info.ApprovedByAdmin != 1"
                :href="paymentHistoryUrl"
                class="profile-header__user-data__change-password"
                >{{ paymentHistory }}</a
              >

              <a
                href="javascript:void(0)"
                class="profile-header__user-data__change-password--dimmed"
                v-if="info.ApprovedByAdmin == 1"
                >{{ changepassword }}</a
              >
              <a
                href="javascript:void(0)"
                v-if="info.ApprovedByAdmin == 1"
                class="profile-header__user-data__change-password--dimmed"
                >{{ formEmailTitle }}</a
              >
              <a
                v-if="info.ApprovedByAdmin == 1"
                href="javascript:void(0)"
                class="profile-header__user-data__change-password--dimmed"
                >{{ paymentHistory }}</a
              >
            </div>
          </div>
          <div class="col-xs-12 col-lg-6 profile-header__edit-profile">
            <div class="profile-header__edit-profile__edit">
              <div class="profile-header__edit-profile__edit__user-id">
                {{ userid }}: {{ info.ProfileID }}
              </div>

              <a
                :href="editUrl"
                class="profile-header__edit-profile__edit__curve-btn custom-btn __yellow"
                v-if="info.ApprovedByAdmin == 2 || info.ApprovedByAdmin == 3"
              >
                <img src="../../../Assets/Images/edit-icon.svg" alt="edit icon" />
                {{ editprofilebtn }}
              </a>
              <a
                href="javascript:void(0)"
                class="profile-header__edit-profile__edit__curve-btn--dimmed custom-btn"
                v-if="info.ApprovedByAdmin == 1"
              >
                <img src="../../../Assets/Images/edit-icon.svg" alt="edit icon" />
                {{ editprofilebtn }}
              </a>
            </div>
          </div>
        </div>
        <div
          class="seprator"
          style="background-image:url('../../../Assets/Images/seprator.svg')"
        ></div>
        <div class="user-details">
          <div class="user-details__item" v-if="info.NationalID == null">
            <div class="user-details__item__title">{{ passportid }}</div>
            <div class="user-details__item__data">
              {{ info.PassportNumber }}
            </div>
          </div>
          <div class="user-details__item" v-else>
            <div class="user-details__item__title">{{ formNationalityId }}</div>
            <div class="user-details__item__data">{{ info.NationalID }}</div>
          </div>

          <div class="user-details__item">
            <div class="user-details__item__title">{{ formNationality }}</div>
            <div class="user-details__item__data">{{ info.Nationality }}</div>
          </div>
          <div class="user-details__item">
            <div class="user-details__item__title">{{ birthOfDate }}</div>
            <div class="user-details__item__data">{{ info.DateOfBirth }}</div>
          </div>
          <div class="user-details__item">
            <div class="user-details__item__title">{{ phone }}</div>
            <div class="user-details__item__data">{{ info.PhoneNumber || "-" }}</div>
          </div>
          <div class="user-details__item">
            <div class="user-details__item__title">{{ address }}</div>
            <div class="user-details__item__data">{{ info.Address || "-" }}</div>
          </div>
          <div class="user-details__item">
            <div class="user-details__item__title">{{ university }}</div>
            <div class="user-details__item__data">{{ info.University || "-" }}</div>
          </div>
          <div class="user-details__item">
            <div class="user-details__item__title">{{ faculty }}</div>
            <div class="user-details__item__data">{{ info.Faculty || "-" }}</div>
          </div>
          <div class="user-details__item">
            <div class="user-details__item__title">{{ graduationYear }}</div>
            <div class="user-details__item__data">
              {{ info.GraduationYear }}
            </div>
          </div>
          <div class="user-details__item">
              <div class="user-details__item__title">{{ isRepresentative }}</div>
              <div class="user-details__item__data" v-if="info.IsRepresentative">
                  {{ formYes }}
              </div>
              <div class="user-details__item__data" v-if="!info.IsRepresentative">
                  {{ formNo }}
              </div>
          </div>
          <div class="user-details__item" v-if="info.IsRepresentative">
              <div class="user-details__item__title">{{ companyName }}</div>
              <div class="user-details__item__data">
                  {{ info.CompanyName }}
              </div>
          </div>
          <div class="user-details__item">
            <div class="user-details__item__title">{{ jobTitle }}</div>
            <div class="user-details__item__data">{{ info.JobTitle || "-" }}</div>
          </div>
        </div>
        <div class="news-letter__loader" v-if="isLoading">
          <img src="../../../Assets/Images/spinner.svg" alt="EDA Spinner" />
        </div>
      </div>
      <div class="toaster" v-bind:class="{ 'show-toaster': genericMessage }">
        {{ responseMsg }}
      </div>
    </div>
    <opt-change-email
      v-if="changeEmailFlag"
      v-on:userProfile="showUserProfile"
      :objOtp="optPage"
    ></opt-change-email>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import optChangeEmail from "../OtpChangeEmail/OTPChangeEmail.vue";
import { headers, key } from "../../../Scripts/genericJSFile.js";

let baseUrl = document.location.origin;
let apiUrl = baseUrl + "";
let idleTime = 0;
export default {
  components: {
    optChangeEmail,
  },
  props: {
    companyName: {
      type: String,
    },
    imgDesktop: {
      type: String,
    },
    imgMobile: {
      type: String,
    },
    editUrl: {
      type: String,
    },
    paymentHistory: {
      type: String,
    },
    paymentHistoryUrl: {
      type: String,
    },
    forgetPasswordPageUrl: {
      type: String,
    },
    editprofilebtn: {
      type: String,
    },
    userprofiletitle: {
      type: String,
    },
    uploadingimg: {
      type: String,
    },
    userid: {
      type: String,
    },
    changepassword: {
      type: String,
    },
    pendingProfileNote: {
      type: String,
    },
    rejectedProfileNote: {
      type: String,
    },
    birthOfDate: {
      type: String,
    },
    address: {
      type: String,
    },
    phone: {
      type: String,
    },
    university: {
      type: String,
    },
    faculty: {
      type: String,
    },
    graduationYear: {
      type: String,
    },
    formNationality: {
      type: String,
    },
    isRepresentative: {
      type: String,
    },
    jobTitle: {
      type: String,
    },
    formNationalityId: {
      type: String,
    },

    passportid: {
      type: String,
    },
    extvalidation: {
      type: String,
    },
    sizevalidation: {
      type: String,
    },
    OTPScreenTitle: {
      type: String,
    },
    OTPScreenConfirmEmail: {
      type: String,
    },
    OTPScreenVerifyCode: {
      type: String,
    },
    OTPScreenVerifyCodeRequired: {
      type: String,
    },
    OTPScreenVerifyCodeNotValid: {
      type: String,
    },
    formEmail: {
      type: String,
    },
    formEmailRequired: {
      type: String,
    },
    formEmailNotValid: {
      type: String,
    },
    formEmailTitle: {
      type: String,
    },
    formEmailSubTitle: {
      type: String,
    },
    successMessage: {
      type: String,
    },
    backBtn: {
      type: String,
    },
    loginPageUrl: {
      type: String,
    },
    homePageUrl: {
      type: String,
    },
    isLoginPage: {
      type: Boolean,
    },
    submit: {
      type: String,
    },
    login: {
      type: String,
    },
    HomePage: {
      type: String,
    },
    formYes: {
        type: String,
    },
    formNo: {
        type: String,
    }
  },
  data() {
    return {
      info: "",
      isLoading: false,
      validExtenstion: false,
      validSize: false,
      selectedImg: "",
        ppurl: "https://ssoapi.edaegypt.gov.eg/profileimage/",
      userPhysicalImg: null,
      token: "",
      optPage: {},
      changeEmailFlag: false,
      genericMessage: false,
      responseMsg: "",
    };
  },
  methods: {
      getInfo() {
        let token = localStorage.getItem("token");
        //if (sessionStorage.getItem("token")) {
        //    token = sessionStorage.getItem("token")
        //} else {
        //    token = localStorage.getItem("token")
        //}
      if (token) {
        axios
            .post(`${apiUrl}/Umbraco/Surface/Users/GetUserProfile`, key, headers)
            .then((response) => {
                this.info = response.data;
                let fullNameEnglish = this.info.FullNameEnglish.split(', ');
                let fullNameArabic = this.info.FullNameArabic.split(', ');
                this.info.FullNameArabic = `${fullNameArabic[0]} ${fullNameArabic[1]} ${fullNameArabic[2]} ${fullNameArabic[3]}`;
                this.info.FullNameEnglish = `${fullNameEnglish[0]} ${fullNameEnglish[1]} ${fullNameEnglish[2]} ${fullNameEnglish[3]}`;
            if (this.info.ProfilePicture) {
                this.info.ProfilePicture = `${this.ppurl}${this.info.ProfilePicture}`;
            } else {
                this.info.ProfilePicture = `${baseUrl}/Assets/Images/profile-picture-500x500.png`;
              }

            if (this.info.DateOfBirth) {
              this.info.DateOfBirth = moment(
                new Date(this.info.DateOfBirth)
              ).format("L");
            } else {
              this.info.DateOfBirth = "-";
            }

            if (this.info.GraduationYear) {
              this.info.GraduationYear = moment(
                new Date(this.info.GraduationYear)
              ).format("YYYY");
            } else {
              this.info.GraduationYear = "-";
              }

          })
          .catch(() => {});
      } else {
        this.info = {};
      }
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    uploadImg() {
      document.getElementById("userImg").click();
    },
    imageSelected(e) {
      e.preventDefault();
      let reader;
      let files = e.target.files;
      if (
        files[0].type == "image/jpeg" ||
        files[0].type == "image/png" ||
        files[0].type == "image/jpg"
      ) {
        this.validExtenstion = false;
      } else {
        this.validExtenstion = true;
        setTimeout(() => {
          this.validExtenstion = false;
        }, 2000);
      }

      if (files[0].size > 1024 * 1024 * 2) {
        this.validSize = true;
        setTimeout(() => {
          this.validSize = false;
        }, 2000);
      } else {
        this.validSize = false;
      }

        if (!this.validExtenstion && !this.validSize) {
            reader = new FileReader();
            reader.onload = (e) => {
                this.info.ProfilePicture = e.target.result;
            };
            this.userPhysicalImg = files[0];
            let token = localStorage.getItem("token");
            //if (sessionStorage.getItem("token")) {
            //    token = sessionStorage.getItem("token")
            //} else {
            //    token = localStorage.getItem("token")
            //}
            if (token != "") {
                let headers = {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': "application/json",
                    },
                };
                let formData = new FormData();
                formData.append("profilePicture", this.userPhysicalImg);

                axios
                    .post(
                        `${apiUrl}/Umbraco/Surface/Users/UpdateProfilePicture`,
                        formData,
                        headers
                    )
                    .then(() => {
                        window.location.reload();
                    });

                reader.readAsDataURL(files[0]);
            }
        }
    },
    changeEmail() {
      this.isLoading = true;
        let token = localStorage.getItem("token");
        //if (sessionStorage.getItem("token")) {
        //    token = sessionStorage.getItem("token")
        //} else {
        //    token = localStorage.getItem("token")
        //}
      if (token) {

        //let headers = {
        //    headers: {
        //        'Authorization': `Bearer ${token}`
        //    },
        //};
          axios
              .post(`${apiUrl}/Umbraco/Surface/Users/SendOTPChangeEmail`, key, headers)
              .then((res) => {
              this.isLoading = false;
              if (res.data.Message == null) {
                this.changeEmailFlag = true;
                  this.optPage.userEmail = res.data.Email;
                  this.optPage.EdaID = res.data.ProfileID;
              } else {
                this.genericMessage = true;
                this.responseMsg = res.data.Message;
                setTimeout(() => {
                  this.genericMessage = false;
                }, 2000);
              }
            });
      }
    },
    showUserProfile(value) {
      this.changeEmailFlag = value;
      document.querySelector(".navbar.navbar-expand-lg").style.display =
        "flex";
      document.querySelector(".breadcrumb-container").style.display = "block";
      document.querySelector(".generic-banner").style.display = "block";
      document.querySelector(".footer").style.display = "block";
      if (document.querySelector(".register-form-container")) {
        document.querySelector(".register-form-container").style.display =
          "block";
      }
      document.querySelector(".copy-right").style.display = "block";
    },
    timerIncrement() {
        idleTime = idleTime + 1;
        if (idleTime > 19) {
            this.signOut();
        }
    },
    signOut() {
        //let token = localStorage.getItem("token");
        //let headers = {
        //    headers: {
        //        'Authorization': `Bearer ${token}`
        //    },
        //};
        axios.post(`${apiUrl}/Umbraco/Surface/Users/signout`, key, headers).then(()=> {
            localStorage.removeItem('token');
            //sessionStorage.removeItem('token');
            window.location.href = this.loginPageUrl;

        }).catch(() => {
        });
    }
  },
  beforeMount() {
    document.addEventListener('mousemove', function () { idleTime = 0 });
    document.addEventListener('keydown', function () { idleTime = 0 });
    this.timerIncrement();
  },
  mounted() {
    setInterval(this.timerIncrement, 60000);

    document.querySelector(".register-page-form__loader").style.display =
    "none";

    this.getInfo();

    this.optPage = {
    imgDesktop: this.imgDesktop,
    imgMobile: this.imgMobile,
    backBtn: this.backBtn,
    userEmail: "",
    isLoginPage: this.isLoginPage,
    loginUrl: this.loginPageUrl,
    homeUrl: this.homePageUrl,
    OTPTitle: this.OTPScreenTitle,
    OTPConfirmEmail: this.OTPScreenConfirmEmail,
    OTPVerifyCode: this.OTPScreenVerifyCode,
    OTPVerifyCodeRequired: this.OTPScreenVerifyCodeRequired,
    OTPVerifyCodeNotValid: this.OTPScreenVerifyCodeNotValid,
    formEmail: this.formEmail,
    formEmailRequired: this.formEmailRequired,
    formEmailNotValid: this.formEmailNotValid,
    formEmailTitle: this.formEmailTitle,
    formEmailSubTitle: this.formEmailSubTitle,
    successMessage: this.successMessage,
    submit: this.submit,
    login: this.login,
    home: this.HomePage,
    EdaID: ""
    };
    
  },
};
</script>
